/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useReducer, useRef, useState } from "react";
import { Link } from "react-router-dom";
import {
	formatCurrency,
	getCategoriasForDropdown,
	getCuentasForDropdown,
	getLink,
	getVendedoresForDropdown,
	getZonasForDropdown,
	isPastDate,
	isVendedor,
	money,
	permisions,
	toast,
	vencimientoNcf,
} from "../../../utils/helpers";
import FiltersContainer from "../../general/FiltersContainer";
import PageHeader from "../../general/PageHeader";
import Select from "react-select";
import useFilters from "../../../hooks/useFilters";
import dayjs from "dayjs";
import Loader from "../../general/Loader";
import Pagination from "../../general/Pagination";
import { request } from "../../../utils/request";
import Modal from "../../general/Modal";
import PrefixedInput from "../../general/PrefixedInput";
import RetencionFields, { faltaMontoRetencion } from "../../general/RetencionFields";
import { apiRequest } from "../../../hooks/apiRequest";
import useLocalStorage from "../../../hooks/useLocalStorage";
import { auth } from "../../../utils/auth";
import Dropdown from "../../general/Dropdown";
import {
	ChequeInfoCobrar,
	DepositoInfo,
	OtroInfo,
	TarjetaInfo,
	TransferenciaInfo,
} from "../utils";
import SelectAsync from "react-select/async";
import { METODOS_PAGO } from "../../../utils/types";
import EstadosCuentaForm from "./EstadoCuentasForm";
import InvalidScreen from "../../general/InvalidScreen";
import PinModal from "../../general/PinModal";

// CALCULOS
// al yo hacer los cálculos de abono y pendiente, voy a recorrer las cuentas y al momento de procesar voy a enviar un form con las datas del state
// Puedo hacer los cálculos igual que como están en el <Row /> pero con el total de las cuentas (preferiblemente usar array.reduce()).

// detalles: Debo tener el monto que le voy a abonar a la cuenta

// VALIDACIÓN
// Hay que validar que todo lo que este en ese objeto sea del mismo cliente o que no me pase cuando el objeto no este vació.
// state template = {cliente: number, nombreCliente: string, cuentas: [{id: number, numeracion: string, balance: float, abono: float}], balanceTotal: float, abonoTotal: float}
// desde el componente Row debo enviar en el dispatch: el idCliente, idCuenta(factura), balance (no por cobrar estático) y el abono.
// cuando vaya a hacer el delete de un campo, que busque por idCuenta

// REDUCER ACTIONS
// agregar información al reducer: {cliente: idCliente, cuenta: {id, balance, abono}}
// eliminar cuenta del reducer: {cuenta: id (id factura)}
// Agregar abono: {idCuenta, abono, balance}
// Calcular abono y deuda total: solo se ejecuta el reducer sin payload

const vencimientoOptions = [
	{ value: "todos", label: "Todos" },
	{ value: "no_vencidas", label: "No Vencidas" },
	{ value: "7-", label: "7 días o menos" },
	{ value: "8_15", label: "8 a 15 días" },
	{ value: "16_30", label: "16 días a 30 días" },
	{ value: "31-45", label: "31 días a 45" },
	{ value: "46+", label: "Más de 46 días" },
	{ value: "incobrable", label: "Incobrable" },
];

const accountsReducer = (state, action) => {
	switch (action.type) {
		case "addAccount":
			if (!state.solicitudPago && state.cliente) {
				if (state.cliente !== action.payload.cliente) {
					return state;
				}

				const nfcTipos = ['B01', 'B02', 'B14', 'B15', 'B16', 'E31', 'E32', 'E32', 'E44', 'E45'];
				const stateEsNfc = nfcTipos.includes(state.cuentas[0].tipo_numeracion);
				const actionEsNfc = nfcTipos.includes(action.payload.cuenta.tipo_numeracion);

				if (stateEsNfc !== actionEsNfc) {
                    toast("No se pueden seleccionar facturas con tipo de numeraciones diferentes.", "error")
					return state;
				}
			}

			return {
				...state,
				cliente: action.payload.cliente,
				nombre: action.payload.nombre,
				cuentas: [...state.cuentas, action.payload.cuenta],
			};

		case "deleteAccount":
			const newCuentas = state.cuentas.filter(
				(cuenta) => cuenta.id !== action.payload.cuenta
			);
			return {
				...state,
				cliente: newCuentas.length > 0 ? state.cliente : null,
				cuentas: newCuentas,
			};

		case "changeAbono":
			const cuentaIndex = state.cuentas.findIndex(
				(cuenta) => cuenta.id === action.payload.cuenta
			);
			state.cuentas[cuentaIndex].abono = action.payload.abono;
			state.cuentas[cuentaIndex].balance = action.payload.balance;
			state.cuentas[cuentaIndex].impuestos = action.payload.impuestos;
			return state;
		case "calcAbonoAndBalance":
			const abonoTotal = state.cuentas.reduce((acc, curr) => {
				return acc + curr.abono;
			}, 0);
			const balanceTotal = state.cuentas.reduce((acc, curr) => {
				return acc + curr.balance;
			}, 0);
			const impuestoTotal = state.cuentas.reduce((acc, curr) => {
				return acc + curr.impuestos;
			}, 0);

			return { ...state, balanceTotal, abonoTotal, impuestoTotal };
		case "toggleSolicitudPago":
			if (state.solicitudPago) return {
				cliente: null,
				nombre: "",
				cuentas: [],
				balanceTotal: 0,
				abonoTotal: 0,
				solicitudPago: false,
			};

			return { ...state, solicitudPago: true };
		default:
			return {
				cliente: null,
				nombre: "",
				cuentas: [],
				balanceTotal: 0,
				abonoTotal: 0,
				impuestoTotal: 0,
				solicitudPago: false,
			};
	}
};

const CuentasPorCobrar = () => {
	const formRef = useRef();
	const [rutasSelected] = useLocalStorage("rutas");

	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);

	const { handleFilterChangeWithoutDebounce, handleFilterChange, filtersQuery, filters } = useFilters({
		incobrable: 0,
		vendedor: isVendedor() ? auth.getUser().empleado?.id : "",
		buscar: urlParams.get('buscar') ?? "",
		zona: "",
		categoria: "",
		desde: null,
		hasta: dayjs().format("YYYY-MM-DD"),
		vencimiento_desde: "",
		vencimiento_hasta: "",
		zonas_selected:
			rutasSelected instanceof Array
				? rutasSelected.map((v) => v.value).join(",")
				: null,
	});
	const [facturas, setFacturas] = useState({ data: [] });
	const [isLoading, setIsLoading] = useState(true);
	const [dropdownOptions, setDropdownOptions] = useState({
		zonas: [],
		vendedores: [],
		categorias: [],
	});
	const [accountsSelected, setAccountsSelected] = useReducer(
		accountsReducer,
		{
			cliente: null,
			nombre: "",
			cuentas: [],
			balanceTotal: 0,
			abonoTotal: 0,
			impuestoTotal: 0,
			solicitudPago: false,
		}
	);
	const [showProcesarModal, setShowProcesarModal] = useState(false);
	const [pagoInfo, setPagoInfo] = useState({
		pago: 0,
		tipo_pago: "",
		fecha: dayjs().format("YYYY-MM-DD"),
        usarRetencion: false,
	});
	const [page, setPage] = useState(1);
	const [saving, setSaving] = useState(false);
	const [vencimientoBtn, setVencimientoBtn] = useState("todos");
	const [totalAdeudado, setTotalAdeudado] = useState(0);
	const [countAdeudado, setCountAdeudado] = useState(0);
	const [totalIncobrable, setTotalIncobrable] = useState(0);
	const [countIncobrable, setCountIncobrable] = useState(0);
	const [totalVigente, setTotalVigente] = useState(0);
	const [countVigente, setCountVigente] = useState(0);
	const [totalVencida, setTotalVencida] = useState(0);
	const [countVencida, setCountVencida] = useState(0);
	const [processBtnSelected, setProcessBtnSelected] = useState("normal");
	const [numeraciones, setNumeraciones] = useState([]);
	const [showEstadoDeCuentaModal, setShowEstadoDeCuentaModal] = useState(false);
    const [rawCuentas, setRawCuentas] = useState([]);
    const [cuentas, setCuentas] = useState([]);

	const [showIncobrableModal, setShowIncobrableModal] = useState(false);
	const [showCobrableModal, setShowCobrableModal] = useState(false);
	const [selectedFactura, setSelectedFactura] = useState(null);
	const [showPINModal, setShowPINModal] = useState(false);
	const callbackPinModal = useRef(() => undefined);
	const [showFilters, setShowFilters] = useState(false);


	const openIncobrableModal = (factura) => {
		setShowIncobrableModal(true);
		setSelectedFactura(factura);
	};

	const openCobrableModal = (factura) => {
		setShowCobrableModal(true);
		setSelectedFactura(factura);
	};

	const closeIncobrableModal = (id) => {
		setShowIncobrableModal(false);
		setSelectedFactura(null);
	};

	const closeCobrableModal = (id) => {
		setShowCobrableModal(false);
		setSelectedFactura(null);
	};

	const openPinModal = () => {
		setShowPINModal(true);
	}

	const closePinModal = () => {
		setShowPINModal(false);
		setSaving(false);
	}

    const toggleFilters = () => {
        setShowFilters(prev => !prev);
    }

	const getCuentasPorCobrar = async (url) => {
		url = url ? url + "&limit=15" : "cuentas-por-cobrar?limit=15";
		request(url).then((data) => {
			setFacturas(data);
			setIsLoading(false);
		});
	};

    const getNumeraciones = async () => {
        request('numeracion-documentos?tipo_documento=factura_venta').then((response) => {
            setNumeraciones(response.data);
        });
    }

    const getCuentas = async () => {
        const response = await request('cuentas');
        return response.data;
    };

	const getTotalAdeudado = async (filtersQuery = "") => {
		const url = `cuentas-por-cobrar/total-adeudado?limit=15&${filtersQuery.substring(1)}`;

		const data = await request(url);

		setTotalAdeudado(data.data?.totalAdeudado);
		setCountAdeudado(data.data?.countAdeudado);

		if (vencimientoBtn === "todos") {
			const [data2, data3, data4] = await Promise.all(
				[
					request(url + "&incobrable=1"),
					request(url + "&vencimiento_desde=" + dayjs().format('YYYY-MM-DD')),
					request(url + "&vencimiento_hasta=" + dayjs().format('YYYY-MM-DD')),
				]
			);

			setTotalIncobrable(data2.data?.totalAdeudado);
			setCountIncobrable(data2.data?.countAdeudado);

			setTotalVigente(data3.data?.totalAdeudado);
			setCountVigente(data3.data?.countAdeudado);

			setTotalVencida(data4.data?.totalAdeudado);
			setCountVencida(data4.data?.countAdeudado);
		}
	};

	const openProcesarModal = () => {
		if (!accountsSelected.cliente) {
			toast(
				"Debe seleccionar al menos un factura para continuar con el proceso",
				"error"
			);
			return;
		} else if (
			accountsSelected.cuentas.findIndex((cuenta) => cuenta.abono <= 0) >=
			0
		) {
			toast(
				"Debe Introducir monto a abonar en facturas seleccionadas para continuar con el proceso",
				"error"
			);
			return;
		}
		setPagoInfo((state) => ({
			...state,
			tipo_pago: "",
			pago: accountsSelected.abonoTotal,
            usarRetencion: false,
            fecha: dayjs().format("YYYY-MM-DD"),
		}));
		setRetenciones(accountsSelected.cuentas.map(cuenta => money(cuenta.impuestos * 0.3)));
		setPage(1);
		setShowProcesarModal(true);
	};

	const openReportSolicitudPago = () => {
		if (!accountsSelected.cliente) {
			toast(
				"Debe seleccionar al menos un compra para continuar con el proceso",
				"error"
			);
			return;
		}

		window.open(
			getLink(
				`/imprimir/cxc/solicitud-pago?ids=${accountsSelected.cuentas.map(cuenta => cuenta.id).join(',')}`
			)
		);

		setAccountsSelected({type: "toggleSolicitudPago"});
	}

	const processTransaction = async (e) => {
		e.preventDefault();
		e.persist();
		setSaving(true);

		const process = async () => {
			const data = new FormData(e.target);
			const response = await apiRequest(data, "cuentas-por-cobrar", "POST");

			if (response.success) {
				if (processBtnSelected === "factura") {
					window.open(
						getLink(
							`/imprimir/facturas/${accountsSelected.cuentas[0]?.id}`
						)
					);
				} else if (processBtnSelected === "factura-doble") {
					window.open(
						getLink(
							`/imprimir/facturas/${accountsSelected.cuentas[0]?.id}/doble`
						)
					);
				} else {
					toast("Transacción procesada con éxito!");
					window.open(
						getLink(
							`/imprimir/recibos-ingreso/${response.data?.recibo}`
						)
					);
				}
				getCuentasPorCobrar(`cuentas-por-cobrar${filtersQuery}`);
				getTotalAdeudado(filtersQuery);
				setShowProcesarModal(false);
				setAccountsSelected({ action: "reset" });
				setSaving(false);
				setIsLoading(true);
				setPage(1);
				setSaving(false);
				return;
			}

			setSaving(false);

            if (response.code === 422) {
                if (typeof response.data.message === 'object') {
                    let errors = Object.keys(response.data.message).map(k => response.data.message[k].join(', '))
                    toast(errors.join(" | "), "error");
                } else {
                    toast("Error procesado la transacción", "error");
                }
            }
		};


		if (pagoInfo.tipo_pago === 'cheque' && isPastDate(pagoInfo.fecha)) {
			callbackPinModal.current = process;
			openPinModal();
		} else {
			await process();
		}
	};

	const incobrable = (id) => {
		const process = async () => {
			const data = new FormData();
			data.append('id', id);
			const response = await apiRequest(data, "incobrable", "POST");

			if (response.success) {
				setAccountsSelected({
					type: "deleteAccount",
					payload: { cuenta: id },
				});

				toast("La factura fue actualizada como incobrable.", "success");

				setIsLoading(true);
				getCuentasPorCobrar(`cuentas-por-cobrar${filtersQuery}`);
				getTotalAdeudado(filtersQuery);
				setPage(1);

				return;
			}

			toast("Error actualizando la cuenta", "error");
		}

		callbackPinModal.current = process;
		openPinModal();
	};

	const cobrable = (id) => {
		const process = async () => {
			const data = new FormData();
			data.append('id', id);
			const response = await apiRequest(data, "cobrable", "POST");

			if (response.success) {
				setAccountsSelected({
					type: "deleteAccount",
					payload: { cuenta: id },
				});

				toast("La factura fue actualizada como cobrable.", "success");

				setIsLoading(true);
				getCuentasPorCobrar(`cuentas-por-cobrar${filtersQuery}`);
				getTotalAdeudado(filtersQuery);
				setPage(1);

				return;
			}

			toast("Error actualizando la cuenta", "error");
		}

		callbackPinModal.current = process;
		openPinModal();
	};

	const confirmIncobrable = () => {
		closeIncobrableModal();

		return incobrable(selectedFactura?.id);
	};

	const confirmCobrable = () => {
		closeCobrableModal();

		return cobrable(selectedFactura?.id);
	};

	const handleVencimientoChange = (dias) => {
		switch (dias) {
			case "todos":
				handleFilterChangeWithoutDebounce("vencimiento_desde", "");
				handleFilterChangeWithoutDebounce("vencimiento_hasta", "");
				setVencimientoBtn("todos");
				break;
			case "no_vencidas":
				handleFilterChangeWithoutDebounce(
					"vencimiento_desde",
					dayjs().format("YYYY-MM-DD")
				);
				handleFilterChangeWithoutDebounce("vencimiento_hasta", "");
				setVencimientoBtn("no_vencidas");
				break;
			case "7-":
				handleFilterChangeWithoutDebounce(
					"vencimiento_desde",
					dayjs().subtract(7, "day").format("YYYY-MM-DD")
				);
				handleFilterChangeWithoutDebounce(
					"vencimiento_hasta",
					dayjs().format("YYYY-MM-DD")
				);
				setVencimientoBtn("7-");
				break;
			case "8_15":
				handleFilterChangeWithoutDebounce(
					"vencimiento_desde",
					dayjs().subtract(15, "day").format("YYYY-MM-DD")
				);
				handleFilterChangeWithoutDebounce(
					"vencimiento_hasta",
					dayjs().subtract(8, "day").format("YYYY-MM-DD")
				);
				setVencimientoBtn("8_15");
				break;
			case "16_30":
				handleFilterChangeWithoutDebounce(
					"vencimiento_desde",
					dayjs().subtract(30, "day").format("YYYY-MM-DD")
				);
				handleFilterChangeWithoutDebounce(
					"vencimiento_hasta",
					dayjs().subtract(16, "day").format("YYYY-MM-DD")
				);
				setVencimientoBtn("16_30");
				break;

			case "31-45":
				handleFilterChangeWithoutDebounce(
					"vencimiento_desde",
					dayjs().subtract(45, "day").format("YYYY-MM-DD")
				);
				handleFilterChangeWithoutDebounce(
					"vencimiento_hasta",
					dayjs().subtract(31, "day").format("YYYY-MM-DD")
				);
				setVencimientoBtn("31-45");
				break;
			case "incobrable":
				handleFilterChangeWithoutDebounce("vencimiento_desde", "");
				handleFilterChangeWithoutDebounce("vencimiento_hasta", "");
				setVencimientoBtn("incobrable");
				break
			default:
				break;
		}

		handleFilterChangeWithoutDebounce("incobrable", dias === "incobrable" ? 1 : 0);
	};

	useEffect(() => {
		if (isVendedor()) {
			setDropdownOptions((state) => ({ ...state, zonas: rutasSelected }));
		} else {
			getZonasForDropdown().then((data) => {
				setDropdownOptions((state) => ({ ...state, zonas: data }));
			});
			getVendedoresForDropdown().then((data) => {
				const [todos, ...vendedores] = data;
				setDropdownOptions((state) => ({ ...state, vendedores: [todos, {value: "0", label: "Sin Vendedor"}, ...vendedores] }));
			});
		}
        getNumeraciones();
        getCuentas().then(data => {
            setRawCuentas(data);
        });
	}, []);

	useEffect(() => {
		if (filtersQuery === "") return;
		getCuentasPorCobrar(`cuentas-por-cobrar${filtersQuery}`);
		getTotalAdeudado(filtersQuery);
	}, [filtersQuery]);

    useEffect(() => {
        let cuentas = auth.manejaCuentas() ? auth.cuentas() : rawCuentas;
        cuentas = cuentas.filter(cuenta => {
            if (auth.esVendedor()) return true;

            if (pagoInfo.tipo_pago === 'efectivo') {
                return cuenta.tipo === 'LOCAL';
            }
            return cuenta.tipo !== 'LOCAL';
        });
        setCuentas(cuentas.map(c => ({label: c.nombre, value: c.id})));
        setPagoInfo((state) => ({
            ...state,
            cuenta: auth.manejaCuentas() && cuentas.length < 2 ? cuentas[0]?.id : "",
        }));
    }, [pagoInfo.tipo_pago])

    const [retenciones, setRetenciones] = useState([]);
    const [usarRetencion, setUsarRetencion] = useState(false);

	/*if (isVendedor() && !localStorage.getItem("rutas")) {
		return <InvalidScreen message="No hay zonas seleccionadas" />;
	}*/

	if (auth.is('vendedor-cliente') && !localStorage.getItem("almacenes")) {
		return <InvalidScreen message="No hay almacenes seleccionados" />;
	}

	return (
		<>
			<PageHeader title="Cuentas por cobrar" hasButton={false}>
                <div className="btn-group d-none d-lg-flex w-100" role="group" style={{marginTop: "-70px"}}>
					<button
                        type="button"
                        className={`btn btn-outline-danger ml-auto ${
                            vencimientoBtn === "incobrable" ? "active" : ""
                        }`}
                        onClick={() => {
							handleFilterChangeWithoutDebounce("vencimiento_desde", "");
                            handleFilterChangeWithoutDebounce("vencimiento_hasta", "");
							handleFilterChangeWithoutDebounce("incobrable", 1);
                            setVencimientoBtn("incobrable");
                        }}
                    >
                        Incobrable
                    </button>
                    <button
                        type="button"
                        className={`btn btn-secondary ${
                            vencimientoBtn === "todos" ? "active" : ""
                        }`}
                        onClick={() => {
                            handleFilterChangeWithoutDebounce("vencimiento_desde", "");
                            handleFilterChangeWithoutDebounce("vencimiento_hasta", "");
							handleFilterChangeWithoutDebounce("incobrable", 0);
                            setVencimientoBtn("todos");
                        }}
                    >
                        Todos
                    </button>
                    <button
                        type="button"
                        className={`btn btn-secondary ${
                            vencimientoBtn === "no_vencidas" ? "active" : ""
                        }`}
                        onClick={() => {
                            handleFilterChangeWithoutDebounce("vencimiento_desde", dayjs().format("YYYY-MM-DD"));
                            handleFilterChangeWithoutDebounce("vencimiento_hasta", "");
							handleFilterChangeWithoutDebounce("incobrable", 0);
                            setVencimientoBtn("no_vencidas");
                        }}
                    >
                        Vigentes
                    </button>
                    <button
                        type="button"
                        className={`btn btn-secondary ${
                            vencimientoBtn === "vencidas" ? "active" : ""
                        }`}
                        onClick={() => {
                            handleFilterChangeWithoutDebounce("vencimiento_desde", "");
                            handleFilterChangeWithoutDebounce("vencimiento_hasta", dayjs().format("YYYY-MM-DD"));
							handleFilterChangeWithoutDebounce("incobrable", 0);
                            setVencimientoBtn("vencidas");
                        }}
                    >
                        Vencidas
                    </button>
                    <button
                        type="button"
                        className={`btn btn-secondary ${
                            vencimientoBtn === "7-" ? "active" : ""
                        }`}
                        onClick={() => {
                            handleFilterChangeWithoutDebounce(
                                "vencimiento_desde",
                                dayjs()
                                    .subtract(7, "day")
                                    .format("YYYY-MM-DD")
                            );
                            handleFilterChangeWithoutDebounce(
                                "vencimiento_hasta",
                                dayjs().format("YYYY-MM-DD")
                            );
							handleFilterChangeWithoutDebounce("incobrable", 0);
                            setVencimientoBtn("7-");
                        }}
                    >
                        7 días o menos
                    </button>
                    <button
                        type="button"
                        className={`btn btn-secondary ${
                            vencimientoBtn === "8_15" ? "active" : ""
                        }`}
                        onClick={() => {
                            handleFilterChangeWithoutDebounce(
                                "vencimiento_desde",
                                dayjs()
                                    .subtract(15, "day")
                                    .format("YYYY-MM-DD")
                            );
                            handleFilterChangeWithoutDebounce(
                                "vencimiento_hasta",
                                dayjs()
                                    .subtract(8, "day")
                                    .format("YYYY-MM-DD")
                            );
							handleFilterChangeWithoutDebounce("incobrable", 0);
                            setVencimientoBtn("8_15");
                        }}
                    >
                        8 - 15 días
                    </button>
                    <button
                        type="button"
                        className={`btn btn-secondary ${
                            vencimientoBtn === "16_30" ? "active" : ""
                        }`}
                        onClick={() => {
                            handleFilterChangeWithoutDebounce(
                                "vencimiento_desde",
                                dayjs()
                                    .subtract(30, "day")
                                    .format("YYYY-MM-DD")
                            );
                            handleFilterChangeWithoutDebounce(
                                "vencimiento_hasta",
                                dayjs()
                                    .subtract(16, "day")
                                    .format("YYYY-MM-DD")
                            );
							handleFilterChangeWithoutDebounce("incobrable", 0);
                            setVencimientoBtn("16_30");
                        }}
                    >
                        16 - 30 días
                    </button>
                    <button
                        type="button"
                        className={`btn btn-secondary ${
                            vencimientoBtn === "31-45" ? "active" : ""
                        }`}
                        onClick={() => {
                            handleFilterChangeWithoutDebounce(
                                "vencimiento_desde",
                                dayjs()
                                    .subtract(45, "day")
                                    .format("YYYY-MM-DD")
                            );
                            handleFilterChangeWithoutDebounce(
                                "vencimiento_hasta",
                                dayjs()
                                    .subtract(31, "day")
                                    .format("YYYY-MM-DD")
                            );
							handleFilterChangeWithoutDebounce("incobrable", 0);
                            setVencimientoBtn("31-45");
                        }}
                    >
                        31 - 45 días
                    </button>
                    <button
                        type="button"
                        className={`btn btn-secondary ${
                            vencimientoBtn === "46+" ? "active" : ""
                        }`}
                        onClick={() => {
                            handleFilterChangeWithoutDebounce(
                                "vencimiento_desde",
                                dayjs()
                                    .subtract(10, "year")
                                    .format("YYYY-MM-DD")
                            );
                            handleFilterChangeWithoutDebounce(
                                "vencimiento_hasta",
                                dayjs()
                                    .subtract(46, "day")
                                    .format("YYYY-MM-DD")
                            );
							handleFilterChangeWithoutDebounce("incobrable", 0);
                            setVencimientoBtn("46+");
                        }}
                    >
                        +46 días
                    </button>
                </div>
				<div className="d-flex w-100 justify-content-center">
					<div className="col-12 col-md-7 d-block d-lg-none mt-2 font-weight-normal">
						<Select
							options={vencimientoOptions}
							isClearable
							placeholder="Todas"
							onChange={(e) => handleVencimientoChange(e.value)}
							styles={{
								control: (styles) => ({
									...styles,
									height: "45px",
									fontSize: "1.2rem",
								}),
							}}
						/>
					</div>
				</div>
				<div
					className="row w-100 justify-content-center"
					style={{ marginLeft: "0px" }}
				>
					<div className="cuentas-por-cobrar__subheader row" style={{justifyContent: "space-between"}}>
						<div className="col flex align-items-center" style={{flexWrap: "nowrap"}}>
							<div className="col-12 col-md-auto col-lg-auto px-3 d-inline-block cuentas-por-cobrar__col">
								{accountsSelected.cliente ? (
									<h3 className="cuentas-por-cobrar__adeudado-title">
										{formatCurrency(
											accountsSelected.abonoTotal +
												accountsSelected.balanceTotal
										)}
									</h3>
								) : (
									<h4 className="cuentas-por-cobrar__adeudado-title">
										<span className="badge badge-success p-1">{ countAdeudado }</span>{formatCurrency(totalAdeudado)}
									</h4>
								)}
								<span className="cuentas-por-cobrar__adeudado-subtitle">
									{vencimientoBtn === "incobrable" ? "TOTAL INCOBRABLE" : "TOTAL ADEUDADO"}
								</span>
							</div>

							{vencimientoBtn === "todos" && !accountsSelected?.cuentas?.length && <div className="col-12 col-md-auto col-lg-auto px-3 d-inline-block cuentas-por-cobrar__col">
								<h4 className="cuentas-por-cobrar__adeudado-title">
									<span className="badge badge-success p-1">{ countVigente }</span> <span>{formatCurrency(totalVigente)}</span>
								</h4>

								<span className="cuentas-por-cobrar__adeudado-subtitle">
									Vigentes
								</span>
							</div>}

							{vencimientoBtn === "todos" && !accountsSelected?.cuentas?.length && <div className="col-12 col-md-auto col-lg-auto px-3 d-inline-block cuentas-por-cobrar__col">
								<h4 className="cuentas-por-cobrar__adeudado-title">
									<span className="badge badge-success p-1">{ countVencida }</span> <span>{formatCurrency(totalVencida)}</span>
								</h4>

								<span className="cuentas-por-cobrar__adeudado-subtitle">
									Vencidas
								</span>
							</div>}

							{vencimientoBtn === "todos" && !accountsSelected?.cuentas?.length && <div className="col-12 col-md-auto col-lg-auto px-3 d-inline-block cuentas-por-cobrar__col">
								<h4 className="cuentas-por-cobrar__adeudado-title">
									<span className="badge badge-success p-1">{ countIncobrable }</span> <span style={{color: "#f00"}}>{formatCurrency(totalIncobrable)}</span>
								</h4>

								<span className="cuentas-por-cobrar__adeudado-subtitle">
									Incobrable
								</span>
							</div>}

							{accountsSelected.cliente && (
								<>
									<div className="w-auto px-3 d-inline-block cuentas-por-cobrar__col-2">
										<h3 className="cuentas-por-cobrar__adeudado-title">
											{formatCurrency(
												accountsSelected.abonoTotal
											)}
										</h3>
										<span className="cuentas-por-cobrar__adeudado-subtitle">
											ABONO
										</span>
									</div>
									<div className="w-auto px-3 d-inline-block cuentas-por-cobrar__col-2">
										<h3 className="cuentas-por-cobrar__adeudado-title">
											{formatCurrency(
												accountsSelected.balanceTotal
											)}
										</h3>
										<span className="cuentas-por-cobrar__adeudado-subtitle">
											PENDIENTE
										</span>
									</div>
								</>
							)}

						</div>
                        <div className="col row" style={{justifyContent: "flex-end", alignItems: "flex-start"}}>
                            <div className="col-md-5 flex">
                                <input
                                    type="search"
                                    placeholder="Buscar..."
                                    className="form-control mt-1"
                                    name="buscar"
                                    defaultValue={filters.buscar}
                                    onChange={(e) =>
                                        handleFilterChange("buscar", e.target.value)
                                    }
                                />
                                <button className="cxc_btn_mostrar-filtros btn" onClick={toggleFilters}>
                                    <i className="zmdi zmdi-filter-list" />
                                </button>
                            </div>
                            <div className="acciones_cuentas-por-cobrar">
                                <Dropdown btnText="Reportes" btnIcon={<i className="zmdi zmdi-print" />}>
                                    {auth.can(permisions.reporteCuentaPorCobrarDetalles) && <Link
                                        to={getLink(
                                            `/imprimir/cuentas-por-cobrar${filtersQuery}`
                                        )}
                                        target="_blank"
                                        className="dropdown-item"
                                    >
                                        Detalles
                                    </Link>}
                                    {auth.can(permisions.reporteCuentaPorCobrarEstadoCuenta) && <li>
                                        <button
                                            onClick={() => setShowEstadoDeCuentaModal(!showEstadoDeCuentaModal)}
                                            className="dropdown-item"
                                        >
                                            Estados de Cuenta
                                        </button>
                                    </li>}
                                    {auth.can(permisions.reporteCuentaPorCobrarResumen) && <Link
                                        to={getLink(
                                            `/imprimir/cuentas-por-cobrar-resumen${filtersQuery}`
                                        )}
                                        target="_blank"
                                        className="dropdown-item"
                                    >
                                        Resumen
                                    </Link>}

                                </Dropdown>

                                <button
                                    className={`au-btn au-btn-icon au-btn--small ml-2 au-btn--green`}
                                    onClick={() => accountsSelected.solicitudPago ? openReportSolicitudPago() : openProcesarModal()}
                                >
                                    <i className="zmdi zmdi-plus mr-1" />
                                    {accountsSelected.solicitudPago ? 'Abrir' : 'PROCESAR'}
                                </button>

                                <div className="btn_solicitud-pago text-right w-100">
                                    <div>
                                        <button
                                            className="btn"
                                            onClick={() => setAccountsSelected({type: "toggleSolicitudPago"})}
                                            style={{textTransform: "none"}}
                                        >
                                            {accountsSelected.solicitudPago ? 'Desactivar' : 'Activar'} solicitud de pago
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
					</div>
				</div>
			</PageHeader>
			<div className={`cxc_filters-container ${showFilters ? "d-block" : ""}`}>
                <FiltersContainer>
                                <div className="col-12 col-md-6 col-lg-2">
                                    <label
                                        style={{ fontSize: "12px", textTransform: "uppercase" }}
                                    >
                                        Numeración
                                    </label>
                                    <Select
                                        name="numeracion"
                                        isClearable
                                        onChange={(values) =>
                                            handleFilterChange("numeracion", values)
                                        }
                                        isMulti
                                        options={[{label: 'Todos', value: ''}].concat(numeraciones.map(numeracion => {
                                            return {
                                                label: numeracion.nombre,
                                                value: numeracion.id,
                                            }
                                        }))}
                                        styles={{
                                            control: (styles) => ({
                                                ...styles,
                                                maxWidth: vencimientoBtn !== "todos" ? "512px" : "100%",
                                                marginRight: "6px"
                                            }),
                                            menu:(styles) => ({
                                                ...styles,
                                                maxWidth: vencimientoBtn !== "todos" ? "512px" : "100%",
                                            }),
                                        }}
                                    />
                                </div>
                    <div className="col-12 col-md-6 col-lg-2">
                        <label>Zona</label>
                        <Select
                            id="zona"
                            options={dropdownOptions.zonas}
                            name="zona"
                            onChange={(e) => handleFilterChange("zona", e.value)}
                            placeholder="Todos"
                            styles={{
                                control: (styles) => ({
                                    ...styles,
                                    height: "38px",
                                }),
                            }}
                        />
                    </div>
                    {!isVendedor() && (
                        <div className="col-md-2">
                            <label>Vendedor</label>
                            <Select
                                id="vendedor"
                                options={dropdownOptions.vendedores}
                                name="vendedor"
                                placeholder="Todos"
                                onChange={(e) =>
                                    handleFilterChange("vendedor", e.value)
                                }
                                styles={{
                                    control: (styles) => ({
                                        ...styles,
                                        height: "38px",
                                    }),
                                }}
                            />
                        </div>
                    )}
                    <div className="col-12 col-md-6 col-lg-2">
                        <label>Categoría</label>
                        <SelectAsync
                            name="categoria"
                            isMulti
                            isClearable
                            placeholder="Todas"
                            cacheOptions
                            defaultOptions
                            loadOptions={async (e) => [...(await getCategoriasForDropdown('Categorías', 'Facturas', e)), 	{
                                value: "sin categoria",
                                label: "Sin Categoria",
                            }]}
                            onChange={(values) =>
                                handleFilterChange(
                                    "categoria",
                                    values instanceof Array
                                        ? values.map((v) => v.value).join(",")
                                        : values
                                )
                            }
                            styles={{
                                control: (styles) => ({
                                    ...styles,
                                }),
                            }}
                        />
                    </div>
                    <div className="col-12 col-md-6 col-lg-2">
                        <label
                            htmlFor="desde"
                            style={{ fontSize: "12px", textTransform: "uppercase" }}
                        >
                            Desde
                        </label>
                        <input
                            type="date"
                            name="desde"
                            id="desde"
                            className="form-control"
                            onChange={(e) =>
                                handleFilterChange("desde", e.target.value)
                            }
                        />
                    </div>
                    <div className="col-12 col-md-6 col-lg-2">
                        <label
                            htmlFor="hasta"
                            style={{ fontSize: "12px", textTransform: "uppercase" }}
                        >
                            Hasta
                        </label>
                        <input
                            type="date"
                            name="hasta"
                            id="hasta"
                            defaultValue={dayjs().endOf("day").format("YYYY-MM-DD")}
                            className="form-control"
                            onChange={(e) =>
                                handleFilterChange("hasta", e.target.value)
                            }
                        />
                    </div>
                </FiltersContainer>
            </div>
			<div className="row pb-4 px-3">
				{isLoading && <Loader />}
				{!isLoading && facturas.data?.length ? (
					<>
						<CuentasListDesktop>
							{facturas.data.map((factura) => (
								<RowDesktop
									key={factura.id}
									factura={factura}
									setAccountsSelected={setAccountsSelected}
									clientSelected={accountsSelected.cliente}
									accountsSelected={accountsSelected}
									incobrable={openIncobrableModal}
									cobrable={openCobrableModal}
								/>
							))}
						</CuentasListDesktop>
						<div className="table-row__mobile w-100">
							{facturas.data.map((factura) => (
								<RowMobile
									key={factura.id}
									factura={factura}
									setAccountsSelected={setAccountsSelected}
									clientSelected={accountsSelected.cliente}
									accountsSelected={accountsSelected}
									openProcesarModal={openProcesarModal}
									incobrable={openIncobrableModal}
									Cobrable={openCobrableModal}
								/>
							))}
						</div>
					</>
				) : (
					<div>
						{!isLoading && (
							<div>No hay ninguna Factura creada.</div>
						)}
					</div>
				)}
				{facturas.links && (
					<Pagination
						links={facturas.links}
						meta={facturas.meta}
						getData={getCuentasPorCobrar}
					/>
				)}
			</div>

			<div className="d-none d-md-block" style={{
				position: 'fixed',
				bottom: 0,
				left: 0,
				right: 0,
				backgroundColor: 'rgba(255,255,255,0.8)',
				padding: '20px',
				textAlign: 'center',
				zIndex: 1000,
			}}>
				<button
					className={`au-btn au-btn-icon au-btn--small ml-2 au-btn--green`}
					onClick={() => accountsSelected.solicitudPago ? openReportSolicitudPago() : openProcesarModal()}
				>
					<i className="zmdi zmdi-plus mr-1" />
					{accountsSelected.solicitudPago ? 'Abrir' : 'PROCESAR'}
				</button>
			</div>


			<Modal
				title="Procesar transacción"
				show={showProcesarModal}
				toggle={() => {
					setShowProcesarModal((state) => !state);
				}}
				footer={
					<ModalFooter
						setShowProcesarModal={setShowProcesarModal}
						pago={pagoInfo.pago}
                        cuenta={pagoInfo.cuenta}
						abono={accountsSelected.abonoTotal}
						page={page}
						setPage={setPage}
						saving={saving}
						formRef={formRef}
						cuentasQty={accountsSelected.cuentas?.length}
						setProcessBtnSelected={setProcessBtnSelected}
						fecha={pagoInfo.fecha}
						usarRetencion={pagoInfo.usarRetencion}
						retenciones={retenciones}
					/>
				}
				size="650px"
			>
				<form
					method="post"
					onSubmit={(e) => processTransaction(e)}
					className={`body-transferencia crear-compra page-${page}`}
					ref={formRef}
				>
					<input
						type="hidden"
						name="contacto_id"
						value={accountsSelected.cliente}
					/>
					<input
						type="hidden"
						name="empleado_id"
						value={isVendedor() ? auth.getUser()?.empleado?.id : ""}
					/>
					<input
						type="hidden"
						name="abono_total"
						value={accountsSelected.abonoTotal}
					/>
					<input
						type="hidden"
						name="balance_total"
						value={accountsSelected.balanceTotal}
					/>
					<div className="transferencia-page py-0">
						<h3
							className="confirmacion-monto text-center"
							style={{ marginBottom: "5px" }}
						>
							{accountsSelected.nombre}
						</h3>
						<div className="row">
                            <div className="col-12 text-center">
							    {accountsSelected.cuentas.map((cuenta, i) => (
                                    <span key={cuenta.numeracion}>
                                        {i > 0 ? ' — ' : ''}<strong className="color-primary">{cuenta.numeracion}</strong>
                                    </span>
                                ))}
                            </div>
						</div>
						<table className="table transaccion-detalles-cuenta mt-2" style={{ minHeight: 'auto', marginBottom: '20px' }}>
							<tbody>
								<tr>
									<td className="p-1"><small>MONTO</small></td>
									<td className="p-1 text-right"><strong>{formatCurrency(accountsSelected.abonoTotal, "$")}</strong></td>
								</tr>
								<tr>
									<td className="p-1"><small>PENDIENTE</small></td>
									<td className="p-1 text-right"><strong>{formatCurrency(accountsSelected.balanceTotal, "$")}</strong></td>
								</tr>
							</tbody>
						</table>

                        <div className="form-group">
							<label>Forma de pago</label>
							<select
								className="form-control"
								name="tipo_pago"
								value={pagoInfo.tipo_pago}
								onChange={(e) => {
									e.persist();
									setPagoInfo((state) => ({
										...state,
										tipo_pago: e.target.value,
									}));
								}}
							>
                                <option value="" disabled>Seleccionar...</option>
								{METODOS_PAGO.map((metodo) => (
									<option key={metodo.value} value={metodo.value}>
										{metodo.label}
									</option>
								))}
							</select>
						</div>

                        {pagoInfo.tipo_pago === 'cheque' ? (
                            <div className="form-group">
                                <label>Fecha</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    id="fecha"
                                    name="fecha"
                                    onChange={(e) => {
                                        const { value } = e.target;

                                        setPagoInfo((state) => ({
                                            ...state,
                                            fecha: value,
                                        }));
                                    }}
                                    min={dayjs().format("YYYY-MM-DD")}
                                    value={pagoInfo.fecha}
                                />
                            </div>
                        ) : (
                            <input
                                type="hidden"
                                className="form-control"
                                name="fecha"
                                value={pagoInfo.fecha}
                            />
                        )}

                        <div className="form-group">
                            <label>Acreditar fondos a cuenta</label>
                            <select
                                name="cuenta_destino"
                                placeholder="Seleccionar..."
                                className="form-control"
                                onChange={(e) => {
                                    e.persist();
                                    setPagoInfo((state) => ({
                                        ...state,
                                        cuenta: e.target.value,
                                    }));
                                }}
                                value={pagoInfo.cuenta}
                            >
                                <option value="">- Seleccionar -</option>
                                {cuentas.map(cuenta => (
                                    <option key={cuenta.value} value={cuenta.value}>{cuenta.label}</option>
                                ))}
                            </select>
                            <input
                                type="hidden"
                                name="cuenta"
                                value={pagoInfo.cuenta}
                            />
                        </div>

                        {pagoInfo.tipo_pago && pagoInfo.tipo_pago !== "efectivo" && (<fieldset>
                            <legend>Información de {pagoInfo.tipo_pago}</legend>
                            {pagoInfo.tipo_pago === "cheque" && <ChequeInfoCobrar />}
                            {pagoInfo.tipo_pago === "tarjeta" && <TarjetaInfo />}
                            {pagoInfo.tipo_pago === "tarjeta-debito" && <TarjetaInfo />}
                            {pagoInfo.tipo_pago === "transferencia" && <TransferenciaInfo />}
                            {pagoInfo.tipo_pago === "deposito" && <DepositoInfo />}
                            {pagoInfo.tipo_pago === "otro" && <OtroInfo />}
                        </fieldset>)}

						<div className="form-group">
							<label>{pagoInfo.usarRetencion ? "Deuda" : "Monto Recibido"}</label>
							<PrefixedInput
								type="number"
								prefix="RD$"
								name="monto"
								value={pagoInfo.pago}
								setValue={(e) =>
									setPagoInfo((state) => ({
										...state,
										pago: e,
									}))
								}
							/>
						</div>
						<RetencionFields
							activa={pagoInfo.usarRetencion}
							onToggle={() => setPagoInfo(prev => ({...prev, usarRetencion: !prev.usarRetencion}))}
							pago={pagoInfo.pago}
							retenciones={retenciones}
							setRetenciones={setRetenciones}
							cuentas={accountsSelected.cuentas}
							retencionesPorDefecto={accountsSelected.cuentas.map(cuenta => money(cuenta.impuestos * 0.3))}
						/>
						<div className="form-group">
							<label>Comentario</label>
							<textarea
								className="form-control"
								name="notas"
							></textarea>
						</div>
					</div>
					<div className="transferencia-page py-0">
						<h3
							className={`text-center confirmacion-monto ${
								page === 1 ? "d-none" : "d-block"
							}`}
							style={{ marginBottom: "0" }}
						>
							{accountsSelected.nombre}
						</h3>
						<div
							className={`text-center ${
								page === 1 ? "d-none" : "d-block"
							}`}
						>
							<small className="uppercase">Confirmación de transacción</small>
						</div>
						<div
							className={`text-center confirmacion-monto ${
								page === 1 ? "d-none" : "d-block"
							}`}
                            style={{fontSize: '24px', fontWeight: "bold", lineHeight: "1.2"}}
						>
                            <div><small style={{fontSize: "12px"}}>MONTO</small></div>
							<div className="color-primary">{formatCurrency(accountsSelected.abonoTotal, "$")}</div>
						</div>
						<div className="table-responsive d-none d-sm-table">
							<table
								className={`table table-fixed ${
									page === 1 ? "d-none" : "d-table"
								}`}
							>
								<tbody>
                                    <tr>
										<td colSpan={3}>
                                            <div>Cuenta de Destino:</div>
                                            <div>Método de pago:</div>
                                        </td>
										<td className="text-capitalize">
                                            <div>{pagoInfo.cuenta?.label}</div>
                                            <div className="text-capitalize">{pagoInfo.tipo_pago}</div>
										</td>
									</tr>
									{pagoInfo.pago -
										accountsSelected.abonoTotal >
										0 && (
										<tr>
											<td colSpan={3}>Devuelta</td>
											<td>
												{formatCurrency(
													pagoInfo.pago -
														accountsSelected.abonoTotal,
													"$"
												)}
											</td>
										</tr>
									)}
									<tr>
										<td style={{ fontWeight: "600" }}>
											NCF/Factura:
										</td>
										<td style={{ fontWeight: "600" }}>
											Deuda:
										</td>
										<td style={{ fontWeight: "600" }}>
											Abono:
										</td>
										<td style={{ fontWeight: "600" }}>
											Restan:
										</td>
										{pagoInfo.usarRetencion && <td style={{ fontWeight: "600" }}>
											Retención:
										</td>}
									</tr>
									{accountsSelected.cuentas.map(
										(cuenta, i) => (
											<tr key={cuenta.id}>
												<td>{cuenta.numeracion}</td>
												<td>
													{formatCurrency(
														cuenta.deuda,
														"$"
													)}
												</td>
												<td>
													{formatCurrency(
														cuenta.abono,
														"$"
													)}
													<input
														type="hidden"
														name={`cuentas[${i}][abono]`}
														value={cuenta.abono}
													/>
												</td>
												<td>
													{formatCurrency(
														cuenta.balance,
														"$"
													)}
													<input
														type="hidden"
														name={`cuentas[${i}][balance]`}
														value={cuenta.balance}
													/>
													<input
														type="hidden"
														name={`cuentas[${i}][id]`}
														value={cuenta.id}
													/>
												</td>
												{pagoInfo.usarRetencion && <td>
													{formatCurrency(retenciones[i], "$")}
												</td>}
											</tr>
										)
									)}
								</tbody>
							</table>
						</div>
                        <table className="table" style={{minHeight: 'auto'}}>
                            <tbody>
                                <tr>
                                    <td><small className="uppercase">Método de pago</small></td>
                                    <td className="text-right uppercase"><strong>{pagoInfo.tipo_pago}</strong></td>
                                </tr>
                            </tbody>
                        </table>
						<div className="d-block d-sm-none">
							{accountsSelected.cuentas.map((cuenta, i) => (
								<table
									key={i}
									className="table mt-3"
								>
									<tbody>
										<tr>
											<td className="p-1"><small className="uppercase"><strong>Cuenta</strong></small></td>
											<td className="p-1 text-right color-primary"><strong>{cuenta.numeracion}</strong></td>
										</tr>
										<tr>
											<td className="p-1"><small className="uppercase">Deuda</small></td>
											<td className="p-1 text-right"><strong>{formatCurrency(cuenta.deuda, "$")}</strong></td>
										</tr>
										<tr>
											<td className="p-1"><small className="uppercase">Abono</small></td>
											<td className="p-1 text-right"><strong>{formatCurrency(cuenta.abono, "$")}</strong></td>
										</tr>
										<tr>
											<td className="p-1"><small className="uppercase">Resta</small></td>
											<td className="p-1 text-right"><strong>{formatCurrency(cuenta.balance, "$")}</strong></td>
										</tr>
									</tbody>
								</table>
							))}
						</div>
					</div>
				</form>
			</Modal>

            <Modal
                show={showEstadoDeCuentaModal}
                blank={true}
                size={"600px"}
                toggle={() => {
                    setShowEstadoDeCuentaModal(false);
                }}
            >
                <EstadosCuentaForm
                    toggle={() => {
                        setShowEstadoDeCuentaModal(false);
                    }}
                    numeraciones={numeraciones}
                />
            </Modal>

			<Modal
                show={showIncobrableModal}
                blank={false}
                size={"600px"}
                toggle={closeIncobrableModal}
				callback={confirmIncobrable}
				title="¿Está seguro de que desea marcar esta factura como incobrable?"
            >
                <div className="clear-both info-row p-t-10 p-b-10 d-none d-md-flex">
					<div className="info-block" style={{ width: "65%" }}>
						<table>
							<tbody id="info-block-1">
								{selectedFactura?.cliente?.nombre && (
									<tr>
										<td
											width="120px"
											className="client-info-title text-uppercase text-right"
										>
											Cliente:
										</td>
										<td
											style={{
												lineHeight: "20px",
												paddingLeft: "10px",
											}}
										>
											{selectedFactura?.cliente?.nombre}
										</td>
									</tr>
								)}
								{selectedFactura?.cliente?.identificacion && (
									<tr>
										<td className="client-info-title text-uppercase text-right">
											RNC/Cédula:
										</td>
										<td style={{ paddingLeft: "10px" }}>
											{selectedFactura?.cliente?.identificacion}
										</td>
									</tr>
								)}
								{selectedFactura?.cliente?.encargado && (
									<tr>
										<td className="client-info-title text-uppercase text-right">
											Responsable:
										</td>
										<td style={{ paddingLeft: "10px" }}>
											{selectedFactura?.cliente?.encargado}
										</td>
									</tr>
								)}
							</tbody>
						</table>
					</div>

					<div
						className="info-block"
						style={{ marginTop: 10 }}
					>
						<table>
							<tbody id="info-block-2">
								{!selectedFactura?.numeracion?.isProforma && (
									<tr>
										<td colSpan={2}>
											<h3
												style={{
													fontSize: "0.9rem",
													paddingBottom: "10px",
													textAlign: "center",
												}}
											>
												{selectedFactura?.numeracion?.nombre}
											</h3>
										</td>
									</tr>
								)}
								{selectedFactura?.fecha && (
									<tr>
										<td className="client-info-title text-uppercase text-right">
											Fecha:
										</td>
										<td style={{ paddingLeft: "10px" }}>
											{dayjs(selectedFactura?.fecha).format(
												"DD/MM/YYYY"
											)}
										</td>
									</tr>
								)}

								{selectedFactura?.numero_comprobante && (
									<tr>
										<td className="client-info-title text-uppercase text-right">
											{selectedFactura?.numeracion?.isProforma
												? "NO.:"
												: "NCF:"}
										</td>
										<td style={{ paddingLeft: "10px" }}>
											{selectedFactura?.numeracion?.isProforma ? `OC${selectedFactura?.numero_comprobante.substring(selectedFactura?.numero_comprobante.length - 5)}` :
											selectedFactura?.numero_comprobante}
										</td>
									</tr>
								)}

								{vencimientoNcf(selectedFactura) && (
									<tr>
										<td className="client-info-title text-uppercase text-right text-small">
											FV:
										</td>
										<td className="text-small" style={{ paddingLeft: "10px" }}>
											{dayjs(
												vencimientoNcf(selectedFactura)
											).format("DD/MM/YYYY")}
										</td>
									</tr>
								)}

								{selectedFactura?.por_cobrar && (
									<tr>
										<td className="client-info-title text-uppercase text-right text-small">
											PENDIENTE:
										</td>
										<td className="text-small" style={{ paddingLeft: "10px" }}>
											{formatCurrency(selectedFactura.por_cobrar)}
										</td>
									</tr>
								)}
							</tbody>
						</table>
					</div>
				</div>
            </Modal>

			<Modal
                show={showCobrableModal}
                blank={false}
                size={"600px"}
                toggle={closeCobrableModal}
				callback={confirmCobrable}
				title="¿Está seguro de que desea revertir el estado de incobrable de esta factura?"
            >
                <div className="clear-both info-row p-t-10 p-b-10 d-none d-md-flex">
					<div className="info-block" style={{ width: "65%" }}>
						<table>
							<tbody id="info-block-1">
								{selectedFactura?.cliente?.nombre && (
									<tr>
										<td
											width="120px"
											className="client-info-title text-uppercase text-right"
										>
											Cliente:
										</td>
										<td
											style={{
												lineHeight: "20px",
												paddingLeft: "10px",
											}}
										>
											{selectedFactura?.cliente?.nombre}
										</td>
									</tr>
								)}
								{selectedFactura?.cliente?.identificacion && (
									<tr>
										<td className="client-info-title text-uppercase text-right">
											RNC/Cédula:
										</td>
										<td style={{ paddingLeft: "10px" }}>
											{selectedFactura?.cliente?.identificacion}
										</td>
									</tr>
								)}
								{selectedFactura?.cliente?.encargado && (
									<tr>
										<td className="client-info-title text-uppercase text-right">
											Responsable:
										</td>
										<td style={{ paddingLeft: "10px" }}>
											{selectedFactura?.cliente?.encargado}
										</td>
									</tr>
								)}
							</tbody>
						</table>
					</div>

					<div
						className="info-block"
						style={{ marginTop: 10 }}
					>
						<table>
							<tbody id="info-block-2">
								{!selectedFactura?.numeracion?.isProforma && (
									<tr>
										<td colSpan={2}>
											<h3
												style={{
													fontSize: "0.9rem",
													paddingBottom: "10px",
													textAlign: "center",
												}}
											>
												{selectedFactura?.numeracion?.nombre}
											</h3>
										</td>
									</tr>
								)}
								{selectedFactura?.fecha && (
									<tr>
										<td className="client-info-title text-uppercase text-right">
											Fecha:
										</td>
										<td style={{ paddingLeft: "10px" }}>
											{dayjs(selectedFactura?.fecha).format(
												"DD/MM/YYYY"
											)}
										</td>
									</tr>
								)}

								{selectedFactura?.numero_comprobante && (
									<tr>
										<td className="client-info-title text-uppercase text-right">
											{selectedFactura?.numeracion?.isProforma
												? "NO.:"
												: "NCF:"}
										</td>
										<td style={{ paddingLeft: "10px" }}>
											{selectedFactura?.numeracion?.isProforma ? `OC${selectedFactura?.numero_comprobante.substring(selectedFactura?.numero_comprobante.length - 5)}` :
											selectedFactura?.numero_comprobante}
										</td>
									</tr>
								)}

								{vencimientoNcf(selectedFactura) && (
									<tr>
										<td className="client-info-title text-uppercase text-right text-small">
											FV:
										</td>
										<td className="text-small" style={{ paddingLeft: "10px" }}>
											{dayjs(
												vencimientoNcf(selectedFactura)
											).format("DD/MM/YYYY")}
										</td>
									</tr>
								)}

								{selectedFactura?.por_cobrar && (
									<tr>
										<td className="client-info-title text-uppercase text-right text-small">
											PENDIENTE:
										</td>
										<td className="text-small" style={{ paddingLeft: "10px" }}>
											{formatCurrency(selectedFactura.por_cobrar)}
										</td>
									</tr>
								)}
							</tbody>
						</table>
					</div>
				</div>
            </Modal>

			<PinModal showModal={showPINModal} close={closePinModal} callback={callbackPinModal.current}></PinModal>
		</>
	);
};

const CuentasListDesktop = ({ children }) => {
	return (
		<div
			className="table-data table-responsive table-row__desktop"
			style={{ overflowX: "visible" }}
		>
			<table className="table table-data2">
				<thead>
					<tr>
						<th>NCF/Numero</th>
						<th>Cliente</th>
						<th>Creación</th>
						<th>Vencimiento</th>
						<th>Total</th>
						<th>Balance</th>
						<th>Vendedor</th>
						<th>Abono</th>
						<th className="text-center">Pendiente</th>
						<th>Acciones</th>
					</tr>
				</thead>
				<tbody>{children}</tbody>
			</table>
		</div>
	);
};

const useFacturaRow = ({ factura, setAccountsSelected, accountsSelected, clientSelected }) => {
	const [account, setAccount] = useState({
		abono: 0,
		balance: parseFloat(factura.por_cobrar),
	});

	const isAccountSelected = accountsSelected.cuentas.findIndex((cuenta) => cuenta.id === factura.id) !== -1;

	const handleChangeAbono = (val) => {
		if (parseFloat(val) > factura.por_cobrar) {
			toast(
				"El monto a abonar no puede exceder el balance de la cuenta",
				"error"
			);
			setAccount({ balance: 0, abono: factura.por_cobrar });
			setAccountsSelected({
				type: "changeAbono",
				payload: {
					cuenta: factura.id,
					abono: factura.por_cobrar,
					impuestos: factura.impuestos,
					balance: 0,
				},
			});
			setAccountsSelected({ type: "calcAbonoAndBalance" });
			return;
		}

		const balance = factura.por_cobrar - parseFloat(val);
		setAccount({
			balance,
			abono: parseFloat(val),
		});
		setAccountsSelected({
			type: "changeAbono",
			payload: {
				cuenta: factura.id,
				abono: parseFloat(val),
				impuestos: factura.impuestos,
				balance,
			},
		});

		setAccountsSelected({ type: "calcAbonoAndBalance" });
	};

	const handleChangeSelected = () => {
		if (!accountsSelected.solicitudPago && clientSelected && clientSelected !== factura.cliente?.id) return;

		if (!!isAccountSelected) {
			setAccount({ balance: factura.por_cobrar, abono: 0 });
			setAccountsSelected({
				type: "deleteAccount",
				payload: { cuenta: factura.id },
			});
		} else {
			setAccountsSelected({
				type: "addAccount",
				payload: {
					cliente: factura.cliente?.id,
					nombre: factura.cliente?.nombre,
					cuenta: {
						id: factura.id,
						numeracion: factura.numero_comprobante,
						tipo_numeracion: factura.numeracion.tipo,
						balance: factura.por_cobrar,
						abono: 0,
						deuda: factura.por_cobrar,
						impuestos: factura.impuestos,
					},
				},
			});
		}

		setAccountsSelected({ type: "calcAbonoAndBalance" });
	};

	const evenAbonoAndBalance = () => {
		setAccount({ balance: 0, abono: factura.por_cobrar });
		setAccountsSelected({
			type: "changeAbono",
			payload: {
				cuenta: factura.id,
				abono: factura.por_cobrar,
				balance: 0,
				deuda: factura.por_cobrar,
				impuestos: factura.impuestos,
			},
		});
		setAccountsSelected({ type: "calcAbonoAndBalance" });
	};

	return { account, isAccountSelected, handleChangeAbono, handleChangeSelected, evenAbonoAndBalance };
};

const RowMobile = React.memo(
	({ factura, setAccountsSelected, clientSelected, accountsSelected, incobrable, cobrable, openProcesarModal }) => {
	const { account, isAccountSelected, handleChangeAbono, handleChangeSelected, evenAbonoAndBalance } =
		useFacturaRow({ factura, setAccountsSelected, accountsSelected, clientSelected });
    const cheque = factura.cheques?.find(c => c.status === 'procesando');

	return (
		<div style={{display: accountsSelected.solicitudPago || !clientSelected || clientSelected === factura.cliente?.id ? 'block' : 'none'}}>
			<fieldset
				className="fieldset px-3 w-100"
				style={{ border: "1px solid rgba(0,138,171,0.4)", margin: '0 0 20px' }}
			>
				<legend className="mb-0">{factura.numero_comprobante}</legend>
                <div className="form-group">
                    <label className="mb-0" style={{textIndent: '-20px', marginLeft: '20px', lineHeight: 1.3}}>
                        {factura.estado !== 'procesando' && (
                            <input
                                className="mr-2"
                                type="checkbox"
                                checked={isAccountSelected}
                                onChange={() => handleChangeSelected()}
                            />
                        )}
                        <strong>{factura.cliente?.codigo} - {factura.cliente?.nombre}</strong>
                    </label>
                    {factura.estado === 'procesando' && cheque && (
                        <div style={{fontSize: '14px'}}>
                            <span className="badge badge-warning uppercase mr-2">Procesando</span>
                            <small className="uppercase">Cheque:</small> {cheque.numero} | <small className="uppercase">Valor:</small> {formatCurrency(cheque.monto)}
                        </div>
                    )}
                </div>
				<table style={{ width: '100%', tableLayout: 'fixed', fontSize: '12px' }}>
                    <thead>
                        <tr>
                            <th width="90px"></th>
                            <th></th>
                        </tr>
                    </thead>
					<tbody>
						<tr>
							<td className="pb-1 uppercase">Creación</td>
							<td className="pb-1 text-right">
                                <span style={{overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', display: 'block'}}>
                                    {dayjs(factura.created_at).format("DD/MM/YYYY hh:mm a")}
                                </span>
                            </td>
						</tr>
						<tr>
							<td className="pb-1 uppercase">Emisión</td>
							<td className="pb-1 text-right">{dayjs(factura.fecha).format("DD/MM/YYYY")}</td>
						</tr>
						<tr>
							<td className="pb-1 uppercase">Vencimiento</td>
							<td className="pb-1 text-right">{dayjs(factura.fecha_vencimiento).format("DD/MM/YYYY")}</td>
						</tr>
						<tr>
							<td className="pb-1 uppercase">Vendedor</td>
							<td className="pb-1 text-right">
                                <span style={{overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', display: 'block'}}>{factura.vendedor ? `${factura.vendedor?.nombre} ${factura.vendedor?.apellido}` : ""}</span>
                            </td>
						</tr>
						<tr style={{borderBottom: '1px solid #ccc'}}>
							<td className="pb-1 uppercase">Total</td>
							<td className="pb-1 text-right">
                                <strong>{formatCurrency(factura.total, "$")}</strong>
                            </td>
						</tr>
						<tr style={{fontSize: '18px'}}>
							<td className="pt-1 uppercase"><small><strong>Balance</strong></small></td>
							<td className="pt-1 text-right">
                                <strong className="color-primary" onClick={() =>
                                        isAccountSelected ? evenAbonoAndBalance() : null
                                    }>
                                    {formatCurrency(factura.por_cobrar, "$")} <i className="zmdi zmdi-copy"></i>
                                </strong>
                            </td>
						</tr>
					</tbody>
				</table>
                {factura.estado !== 'procesando' && (
                    <div className="row mt-2">
                        <div className="form-group col-6 pr-1 mb-1">
                            <input
                                type="number"
                                step="0.01"
                                value={account.abono}
                                onChange={(e) => handleChangeAbono(e.target.value)}
                                className="form-control"
                                readOnly={!isAccountSelected || accountsSelected.solicitudPago}
                            />
                        </div>
                        <div className="col-6 pl-1 mb-1">
                            <button
                                className="btn btn-outline-primary h-100 w-100"
                                disabled={accountsSelected.solicitudPago}
                                onClick={() => openProcesarModal()}
                            >
                                PROCESAR ABONO
                            </button>
                        </div>
                    </div>
                )}
			</fieldset>
		</div>
	);
});

const RowDesktop = React.memo(
	({ factura, setAccountsSelected, clientSelected, accountsSelected, incobrable, cobrable }) => {
		const { account, isAccountSelected, handleChangeAbono, handleChangeSelected, evenAbonoAndBalance } =
			useFacturaRow({ factura, setAccountsSelected, accountsSelected, clientSelected });
        const cheque = factura.cheques?.find(c => c.status === 'procesando');

		return (
			<tr className="tr-shadow" key={factura.id} style={{display: accountsSelected.solicitudPago || !clientSelected || clientSelected === factura.cliente?.id ? 'table-row' : 'none'}}>
				<td>
					<div className="form-check">
                        {factura.estado !== 'procesando' && (
                            <input
                                className="form-check-input"
                                type="checkbox"
                                checked={isAccountSelected}
                                onChange={() => handleChangeSelected()}
                            />
                        )}
						<label
							className="form-check-label"
							htmlFor="defaultCheck1"
						>
							{factura.numero_comprobante}
						</label>
                        {factura.estado === 'procesando' && cheque && (
                            <div className="d-flex align-items-center">
                                <span className="badge badge-warning uppercase">Procesando</span>
                                <a href={getLink(`/cheques/${cheque.id}`)} target="_blank" style={{color: "#444"}}><i className="zmdi zmdi-info ml-1"></i></a>
                            </div>
                        )}
					</div>
				</td>
				<td>
                    {factura.cliente?.codigo} - {factura.cliente?.nombre}
                    {factura.estado === 'procesando' && cheque && (
                        <div>
                            <small className="uppercase">Cheque:</small> {cheque.numero} | <small className="uppercase">Valor:</small> {formatCurrency(cheque.monto)}
                        </div>
                    )}
                </td>
				<td>
					{dayjs(factura.created_at).format("DD/MM/YYYY hh:mm a")}
				</td>
				<td>{dayjs(factura.fecha_vencimiento).format("DD/MM/YYYY")}</td>
				<td>{formatCurrency(factura.total, "$")}</td>
				<td>{formatCurrency(factura.por_cobrar, "$")}</td>
				{factura.vendedor ? (
					<td>
						{`${factura.vendedor?.nombre} ${factura.vendedor?.apellido}`}
					</td>
				) : (
					<td></td>
				)}

				<td>
					<input
						type="number"
						step="0.01"
						value={account.abono || ''}
						onChange={(e) => handleChangeAbono(e.target.value)}
						className="form-control"
						readOnly={!isAccountSelected || accountsSelected.solicitudPago}
					/>
				</td>
				<td>
					<input
						type="text"
						className="form-control"
						style={{ cursor: "pointer" }}
						readOnly
						value={formatCurrency(account.balance, "$")}
						onClick={() =>
							isAccountSelected ? evenAbonoAndBalance() : null
						}
					/>
				</td>
				<td>
					<Dropdown
						btnText=""
						btnIcon={<i className="zmdi zmdi-more-vert"></i>}
						styles={{
							dropdownMenu: {
								left: "-350%",
							},
						}}
					>
						<Link
							to={getLink(`/imprimir/facturas/${factura.id}`)}
							target="_blank"
							className="dropdown-item"
							title="Impresión normal"
						>
							Impresión
						</Link>
						{/* <Link
							to={getLink(
								`/imprimir/facturas/${factura.id}/doble`
							)}
							target="_blank"
							className="dropdown-item d-none d-sm-block"
							title="Impresión Doble"
						>
							Impresión doble
						</Link> */}
						<Link
							to={getLink(
								`/consultas/historial-pagos-facturas/${factura.id}`
							)}
							className="dropdown-item"
							onClick={() => {
								localStorage.setItem(
									"factura",
									factura?.numero_comprobante
								);
							}}
						>
							Historial de pagos
						</Link>

						{accountsSelected.cuentas.length === 1 && isAccountSelected && <button
							className="dropdown-item"
							onClick={() => {
								incobrable(factura);
							}}
						>
							Incobrable
						</button>}

						{factura.estado === "incobrable" && <button
							className="dropdown-item"
							onClick={() => {
								cobrable(factura);
							}}
						>
							Revertir
						</button>}
					</Dropdown>
				</td>
			</tr>
		);
	}
);

const ModalFooter = React.memo(
	({
		setShowProcesarModal,
		pago,
		cuenta,
		abono,
		page,
		setPage,
		saving = false,
		formRef,
		cuentasQty,
		setProcessBtnSelected,
		fecha,
		usarRetencion,
		retenciones,
	}) => {
		const prevPage = () => setPage((state) => state - 1);
		const nextPage = () => {
            if (formRef.current.checkValidity() === false) {
                formRef.current.reportValidity();
                toast(
                    "Favor revisar todos los campos.",
                    "error"
                );
                return;
            }
            formRef.current.parentElement.scrollTop = 0;
            if (!cuenta) {
                toast(
                    "Debes seleccionar la cuenta donde se acreditarán los fondos",
                    "error"
                );
                return;
            }
			if (parseFloat(pago) <= 0) {
				toast(
					"El valor del abono no puede ser igual o menor a cero",
					"error"
				);
				return;
			}
			if (abono > pago) {
				toast(
					"El valor del pago no puede ser menor al abono seleccionado",
					"error"
				);
				return;
			}
			if (!fecha) {
				toast("Elija una fecha para continuar", "error");
				return;
			}
			if (usarRetencion && faltaMontoRetencion(retenciones)) {
				toast("Debe ingresar el monto de la retención.", "error");
				return;
			}
			setPage((state) => state + 1);
		};
		const submitForm = async (btnClicked) => {
			await setProcessBtnSelected(btnClicked);
			formRef.current.dispatchEvent(
				new Event("submit", { bubbles: true, cancelable: true })
			);
		};

		return (
			<>
				{page === 1 && (
                    <button
                        type="button"
                        onClick={() => setShowProcesarModal((state) => !state)}
                        className="btn btn-plain"
                        style={{
                            gridColumnStart: 1,
                            gridRowStart: 1
                        }}
                    >
                        Cancelar
                    </button>
                )}
				{/* {page === 2 && cuentasQty <= 3 && !saving && (
					<button
						className="btn btn-outline-primary mr-2"
						onClick={() => submitForm("factura-doble")}
                        style={{
                            gridColumnStart: 2,
                            gridRowStart: 'auto'
                        }}
					>
						Factura Doble
					</button>
				)}
				{page === 2 && cuentasQty <= 3 && !saving && (
					<button
						className="btn btn-outline-primary mr-2"
						onClick={() => submitForm("factura")}
                        style={{
                            gridColumnStart: 2,
                            gridRowStart: 'auto'
                        }}
					>
						Factura
					</button>
				)} */}
				{page === 2 && (
					<button
						type="button"
						onClick={prevPage}
						className="btn btn-plain float-left"
                        style={{
                            gridColumnStart: 1,
                            gridRowStart: 1
                        }}
					>
						&larr; Atrás
					</button>
				)}
				{page === 1 && (
					<button
						type="button"
						onClick={nextPage}
						className="btn btn-primary"
                        style={{
                            gridColumnStart: 2,
                            gridRowStart: 'auto'
                        }}
					>
						Continuar
					</button>
				)}
				{page === 2 &&
					(saving ? (
						<Loader type="small" />
					) : (
						<button
							className="btn btn-primary"
							type="button"
							onClick={() => submitForm("normal")}
                            style={{
                                gridColumnStart: 2,
                                gridRowStart: 'auto'
                            }}
						>
							Ingreso
						</button>
					))}
			</>
		);
	}
);

export default CuentasPorCobrar;
